import { useState } from 'react';

function useError() {
    const [error, setError] = useState('');

    const showError = (textError) => {
        setError(textError);
    };

    return {
        error,
        showError
    };
};

export default useError;